export default __webpack_public_path__ + "static/media/delete_white_icon.de5a5b37.svg";